/*
 * --------------------------------------------------------------------------- *
 * File: context.js                                                            *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Tue Nov 01 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useState, createContext, useRef } from "react";

export const AppContext = createContext();

export const AppContextProvider = (props) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [flashRequired, setFlashRequired] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(true);
  const [customerId, setCustomerId] = useState("dummycustomer");
  const [showNow, setShowNow] = useState("DASHBOARD");
  const [collateral, setCollateral] = useState({});
  var [selectedEditDataType, setSelectedEditDataType] = useState({});
  const allowNextRef = useRef(true);

  return (
    <AppContext.Provider
      value={{
        authenticated,
        setAuthenticated,
        flashRequired,
        setFlashRequired,
        forceRefresh,
        setForceRefresh,
        customerId,
        setCustomerId,
        showNow,
        setShowNow,
        collateral,
        setCollateral,
        allowNextRef,
        selectedEditDataType,
        setSelectedEditDataType,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
